import { render, staticRenderFns } from "./IndexEvaluation.vue?vue&type=template&id=02687bcb&"
import script from "./IndexEvaluation.vue?vue&type=script&lang=ts&"
export * from "./IndexEvaluation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports